import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import {
  IPublishTermsRequest,
  TPublishTermsModel,
  IMappers,
  IPublishTermsResponse,
  IPublishTermsResponseError,
  TPublishTermsResponse,
} from './types';

const defaultConfig: TPublishTermsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'billing-tariffs',
  pathApi: '/v1/add-form/publish-terms/',
  hostType: 'api',
};

function createPublishTermsModel(parameters: IPublishTermsRequest): TPublishTermsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublishTermsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IPublishTermsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchPublishTerms<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IPublishTermsOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TPublishTermsResponse> {
  const { response, statusCode } = await httpApi.fetch(createPublishTermsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublishTermsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IPublishTermsResponseError);
    }
  }

  return { response, statusCode } as TPublishTermsResponse;
}

export { defaultConfig, createPublishTermsModel, fetchPublishTerms };
